import React from 'react';
import { useToast } from '../context/ToastContext';
import './ToastContainer.css'; // We will create this CSS file next

const ToastContainer = () => {
  const { toastState, hideToast } = useToast();
  const { visible, type, message } = toastState;

  if (!visible) {
    return null;
  }

  return (
    <div className={`toast-container toast-${type}`}>
      <div className="toast-message">{message}</div>
      <button className="toast-close-btn" onClick={hideToast} aria-label="Close">&times;</button>
    </div>
  );
};

export default ToastContainer; 